import { Component, ComponentFactoryResolver, OnInit, ViewEncapsulation, Type,
  ViewChild, ViewContainerRef, AfterContentInit
} from '@angular/core';
import { Subject } from 'rxjs';

import { PuiMenuMainComponent } from '../../elements/index';
import { PuiAppSettings, PuiMenuPlacement, PuiMenuService } from '../../../core/index';

declare var Layout: any;

@Component({
  selector: 'pui-sidebar',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'sidebar.component.html'
})
export class PuiSidebarComponent implements OnInit, AfterContentInit {
  @ViewChild('smenu', { read: ViewContainerRef }) smenu: ViewContainerRef;
  appSettings: any;
  menuComponent: Type<any>;
  private menuInstance: PuiMenuMainComponent;
  private filterTerms = new Subject<string>();

  constructor(private menuService: PuiMenuService,
    private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    // The Sidebar is responsible for drawing Side menu. We will add filter functionality
    // as we progress to allow users to filter the list
    this.appSettings = PuiAppSettings;
    this.menuComponent = this.menuService.get(PuiMenuPlacement.Main);

    this.filterTerms
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe(term => this.menuInstance.filter(term));

    if (this.menuComponent) {
      const menuComponent = this.componentFactoryResolver.resolveComponentFactory(this.menuComponent);
      if (menuComponent && menuComponent.componentType.prototype instanceof PuiMenuMainComponent) {
        setTimeout(() => {
          if (this.smenu) {
            // at this point we want the "child" component to be rendered into the app.component:
            this.menuInstance = this.smenu.createComponent(menuComponent).instance;
          }
        });
      }
    }
  }

  ngAfterContentInit(): void {
    Layout.initSidebar();
  }

  filterMenu(term: any) {
    this.filterTerms.next(term);
  }

  clearFilter(filterBox: any) {
    filterBox.value = null;
    this.filterTerms.next(null);
  }
}
